import { render } from "./VendorsDetails.vue?vue&type=template&id=c152e88a&ts=true"
import script from "./VendorsDetails.vue?vue&type=script&lang=ts"
export * from "./VendorsDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__